import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getModelAvailableColumns } from './api';

export const path = '/calculator-tariff/model/list';

const PageModelList: React.FC = (props) => {
  const Model = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getModelAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Model {...props} />;
};

export default PageModelList;
